import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from "../../services/api";
import Stripe from "stripe";
import axios from "axios";

const stripeKey = process.env.REACT_APP_STRIPE_SECRET_KEY;
const cancelUrl = process.env.REACT_APP_API_URL + "/subscription/cancel";
const successUrl =
  process.env.REACT_APP_URL +
  "/payment-successful?session_id={CHECKOUT_SESSION_ID}";
const failureUrl = process.env.REACT_APP_URL + "/payment-failed";
const stripe = new Stripe(stripeKey);

export const doSubscribe = createAsyncThunk(
  "subscribe/doSubscribe",
  async ({ priceId, planId, customerId }, { rejectWithValue }) => {
    try {
      const session = await stripe.checkout.sessions.create({
        line_items: [
          {
            price: priceId,
            quantity: 1,
          },
        ],
        mode: "subscription",
        success_url: successUrl,
        cancel_url: failureUrl,
        customer: customerId,
      });
      if (session?.url) window.location.href = session?.url;
      return { planId: planId };
    } catch (error) {
      console.log(error);
      return rejectWithValue(error);
    }
  }
);

export const doSendCheckoutId = createAsyncThunk(
  "subscribe/doSendCheckoutId",
  async ({ checkoutSessionId }, { rejectWithValue }) => {
    try {
      const params = {
        checkoutSessionId: checkoutSessionId,
      };
      await api.post("/subscription/subscribe", params);
      return null;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error);
    }
  }
);

export const doCancelSubscription = createAsyncThunk(
  "subscribe/doCancelSubscription",
  async ({}, { rejectWithValue }) => {
    try {
      await axios.post(cancelUrl);
      return null;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error);
    }
  }
);
